<template>
  <div class="event-thumbnail event">
    <router-link :to="'/events/' + event.slug">
      <div class="event-thumbnail__image">
        <img v-if="event.image" :src="event.image.sizes.medium" :alt="event.image.alt" />
        <img v-else class="fallback-image" src="../assets/society-s-black.png" />
      </div>

      <div class="event-thumbnail__content">

        <h2>{{ event.title }}</h2>

        <!-- Date -->
        <dl v-if="event.event_start">
          <dt>
            <FontAwesomeIcon :icon="icon.calendar" />
            Event Date</dt>
          <dd>
            <span class="from">{{ event.event_start | moment(dateFormat) }}</span>
            <template v-if="event.event_end !== event.event_start"> - <span class="to">{{ event.event_end | moment(dateFormat) }}</span></template>
          </dd>
        </dl>

        <!-- Time -->
        <dl>
          <dt>
            <FontAwesomeIcon :icon="icon.clock" />
            Event Time</dt>
          <dd v-if="event.event_start_time">
            <span class="from">{{ event.event_start + ' ' + event.event_start_time | moment(hoursFormat) }}</span>
            <span class="to"> - {{ event.event_end + ' ' + event.event_end_time | moment(hoursFormat) }}</span>
          </dd>
          <dd v-else>
            All Day
          </dd>
        </dl>

        <!-- Venue -->
        <dl v-if="event.location">
          <dt>
            <FontAwesomeIcon :icon="icon.mapMarker" />
            {{ event.location.name }}</dt>
        </dl>

        <p v-html="event.excerpt"></p>

        <p><span class="btn lrg">More Info</span></p>
      </div>
    </router-link>
  </div>
</template>

<script>
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { faCalendarDays, faClock } from '@fortawesome/free-regular-svg-icons';

export default {
  name: 'EventThumbnail',
  props: {
    event: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      icon: {
        calendar: faCalendarDays,
        clock: faClock,
        mapMarker: faLocationDot
      },
      dateFormat: 'MMMM D, YYYY',
      hoursFormat: 'h:mm a'
    }
  }
}
</script>
